<script setup>
import { onMounted, ref } from 'vue'
import GameCenterGame from './GameCenterGame.vue';

const game = ref(null)

onMounted(() => {
    const url = route('api.group.games.all_star')

    fetch(url)
        .then(response => response.json())
        .then(data => {
            game.value = data.data.game
        })
})
</script>

<template>

<h2 v-if="game" class="mt-4">ALL STARS</h2>
<div v-if="game" class="match-top">
    <div class="match-top__item display20 bold-text gray-text">Гости</div>
    <div class="match-top__item display20 bold-text gray-text">Хозяева</div>
</div>

<div v-if="game" class="match-items">
    <game-center-game :game="game"/>
</div>

</template>
